import ShoppingListDetail from './shopping_list_detail'

export default ShoppingListDetail
